import { ApiEndpoints } from "api/endpoints";
import { makeMutation } from "api/api";
import * as z from "zod";
import { generalErrorCodes } from "shared/errors/generalErrorCodes";
import { TFunction } from "i18next";

const RequestPasswordResetSchema = z.object({
  success: z.literal(true),
});
export interface MutateRequestPasswordResetParams {
  emailAddress: string;
}

export const mutateRequestPasswordReset = async (values: MutateRequestPasswordResetParams) => {
  const response = await makeMutation(ApiEndpoints.requestPasswordReset(), values, false, 'POST', requestPasswordResetErrorCodes);
  return RequestPasswordResetSchema.parse(response);
};

export const requestPasswordResetErrorCodes = {
  ...generalErrorCodes,
  USER_NOT_FOUND: {
    code: "USER_NOT_FOUND",
    translation: (t: TFunction) => t("User not found"),
  },
  EMAIL_NOT_VALID: {
    code: "EMAIL_NOT_VALID",
    translation: (t: TFunction) => t("Invalid email address"),
  },
  TOO_MANY_REQUESTS: {
    code: "TOO_MANY_REQUESTS",
    translation: (t: TFunction) => t("Too many attempts, try again later"),
  },
};
